export const isValidPhoneCharacter = (charInput: string) => {
  // Only allow 0-9, (, ), and -
  const allowedCharactersRegex = /^[\d()-]*$/im;
  return allowedCharactersRegex.test(charInput);
};
